<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-3">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>

    <b-card>
      <b-row class="mb-2 px-2">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-form-group>
            <label
              for="filter_search"
            >
              <strong>
                Search
              </strong>
            </label>
            <b-input
              id="filter_search"
              v-model="tableStatuses.filter"
              type="text"
              placeholder="search here"
              debounce="1000"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="px-1"
        >
          <b-button
            type="button"
            variant="primary"
            @click="onShowAddFormStatus"
          >
            Add Status
          </b-button>
        </b-col>

      </b-row>

      <b-table
        ref="tableStatuses"
        hover
        responsive
        show-empty
        class="mt-2"
        :per-page="tableStatuses.perPage"
        :current-page="tableStatuses.currentPage"
        :items="myProvider"
        :fields="tableStatuses.fields"
        :sort-by.sync="tableStatuses.sortBy"
        :sort-desc.sync="tableStatuses.sortDesc"
        :sort-direction="tableStatuses.sortDirection"
        :filter="tableStatuses.filter"
        :filter-included-fields="tableStatuses.filterOn"
      >
        <template #cell(index)="row">
          {{ tableStatuses.currentPage * tableStatuses.perPage - tableStatuses.perPage + (row.index + 1) }}
        </template>

        <template #cell(active)="row">
          {{ row.item.active == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(attachable)="row">
          {{ row.item.attachable == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(costable)="row">
          {{ row.item.costable == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(on_create_default)="row">
          {{ row.item.on_create_default == 1 ? 'Yes' : 'No' }}
        </template>

        <template #cell(status_name)="row">
          <div class="text-nowrap">
            <strong>{{ row.value }}</strong>
          </div>
        </template>

        <template #cell()="row">
          <div class="text-nowrap">
            {{ row.value }}
          </div>
        </template>

        <template #cell(action)="row">
          <div class="text-nowrap">
            <b-button
              size="sm"
              @click="onShowEditFormStatus(row.item)"
            >
              Edit
            </b-button>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col
          cols="12"
          sm="6"
        >
          <div class="w-100 w-sm-25 mb-2 sm-mb-2">
            <b-select
              v-model="tableStatuses.perPage"
              :options="tableStatuses.pageOptions"
              size="sm"
            />
          </div>
        </b-col>
        <b-col
          cols="12"
          sm="6"
          class="d-flex justify-content-center justify-content-sm-end"
        >
          <b-pagination
            v-model="tableStatuses.currentPage"
            :total-rows="tableStatuses.totalRows"
            :per-page="tableStatuses.perPage"
            first-number
            last-number
            pills
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
          />
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      id="modal-status"
      scrollable
      no-close-on-backdrop
      :title="modalStatusTitle"
      aria-hidden="false"
      @ok="onValidateFormStatus"
    >
      <ValidationObserver
        ref="formStatus"
      >
        <form
          id="formStatus"
          novalidate
          @submit.prevent
        >

          <ValidationProvider
            #default="{ errors }"
            name="status name"
            vid="status_name"
            rules="required|max:100"
          >
            <b-form-group>
              <label for="status_name">
                <strong>
                  Status
                </strong>
              </label>
              <b-input
                id="status_name"
                v-model="status.status_name"
                type="text"
                :state="errors.length > 0 ? false : null"
                placeholder="enter status name"
                autocomplete="off"
              />
              <div
                v-if="errors.length > 0"
                class="invalid-feedback"
              >
                <span>{{ errors[0] }}</span>
              </div>
            </b-form-group>
          </ValidationProvider>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="on_create_default"
              v-model="status.on_create_default"
              name="on_create_default"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Default for Item Creation?
            </b-form-checkbox>
          </div>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="attachable"
              v-model="status.attachable"
              name="attachable"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Attachable?
            </b-form-checkbox>
          </div>

          <div
            class="form-group"
          >
            <b-form-checkbox
              id="costable"
              v-model="status.costable"
              name="costable"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Has Cost?
            </b-form-checkbox>
          </div>

          <div
            v-if="state.editing"
            class="form-group"
          >
            <b-form-checkbox
              id="is_active"
              v-model="status.active"
              name="is_active"
              value="1"
              unchecked-value="0"
              :disabled="state.busy"
              switch
            >
              Is Active?
            </b-form-checkbox>
          </div>

        </form>
      </ValidationObserver>

      <template #modal-footer="{ok, cancel}">
        <b-button
          variant="success"
          :disabled="state.busy"
          @click="ok()"
        >
          {{ state.editing ? 'Update Record' : 'Save Record' }}
        </b-button>
        <b-button
          variant="danger"
          :disabled="state.busy"
          @click="cancel()"
        >
          Close Window
        </b-button>
      </template>

    </b-modal>
  </b-container>
</template>
<script>
import _ from 'lodash'
import { core } from '@/config/pluginInit'
import { AdminStatusService } from '@/services'
import formatter from '@/mixins/formatter'

export default {
  name: 'AdminStatuses',

  middleware: ['auth', 'admin'],

  metaInfo () {
    return {
      title: 'Statuses'
    }
  },

  mixins: [formatter],

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      list: {
        validations: [
          { label: 'Attachable', validator: 'attachable', attachable: false },
          { label: 'Costable', validator: 'costable', costable: false },
          { label: 'Costable', validator: 'costable', costable: false }
        ],
        actions: [
          { label: 'On Assign Item Details' },
          { label: 'On Return Item Details' },
          { label: 'On Attach Item Details' },
          { label: 'On Detach Item Details' }
        ]
      },
      status: {
        id: null,
        status_name: null,
        attachable: 0,
        costable: 0,
        on_create_default: 0,
        active: 0
      },
      tableStatuses: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        fields: [
          { key: 'index', class: 'text-center' },
          { key: 'action', class: 'text-center' },
          { key: 'status_name', label: 'status', sortable: true },
          { key: 'attachable', class: 'text-center' },
          { key: 'costable', class: 'text-center' },
          { key: 'on_create_default', label: 'default', class: 'text-center' },
          { key: 'active', class: 'text-center' },
          { key: 'updated_at', formatter: this.dateTimeShortFormatter, sortable: true }
        ]
      }
    }
  },

  computed: {
    modalStatusTitle () {
      return this.state.editing ? 'Edit Status' : 'Add Status'
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async myProvider (ctx) {
      return await AdminStatusService.get(
        this.objectToUrl({
          page: ctx.currentPage,
          per_page: ctx.perPage,
          sort: ctx.sortBy,
          sort_desc: ctx.sortDesc,
          filter_text: ctx.filter
        })
      ).then(({ data }) => {
        this.tableStatuses.totalRows = data.total_rows
        return data.items
      }).catch(() => {
        return []
      })
    },

    onShowAddFormStatus () {
      this.state.editing = false
      this.status.id = null
      this.status.status_name = null
      this.status.active = 1
      this.status.attachable = 0
      this.status.costable = 0
      this.status.on_create_default = 0

      this.$bvModal.show('modal-status')
    },

    onShowEditFormStatus (status) {
      this.state.editing = true
      this.status.id = status.id
      this.status.status_name = status.status_name
      this.status.active = status.active
      this.status.attachable = status.attachable
      this.status.costable = status.costable
      this.status.on_create_default = status.on_create_default

      this.$bvModal.show('modal-status')
    },

    async onValidateFormStatus (bvModalEvt) {
      bvModalEvt.preventDefault()
      await this.$refs.formStatus.validate().then(async success => {
        if (success) {
          let text = 'Do you really want to create status?'
          if (this.state.editing) {
            text = 'Do you really want to save changes?'
          }
          this.$swal.fire({
            icon: 'question',
            title: 'Question',
            text: text,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Yes',
            cancelButtonColor: '#FF2929',
            showCancelButton: true,
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.state.busy = true
              if (this.state.editing) {
                return this.onPutFormStatus()
              } else {
                return this.onPostFormStatus()
              }
            },
            allowOutsideClick: () => !this.$swal.isLoading()
          })
        } else {
          this.$bvModal.msgBoxOk(
            'Oops! There were problem with your inputs.', {
              title: 'Validation Error',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              centered: true
            }
          )
        }
      })
    },

    async onPostFormStatus () {
      return new Promise(resolve => {
        AdminStatusService.post(this.status).then(({ data }) => {
          this.state.busy = false
          this.$bvModal.hide('modal-status')
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            this.$refs.tableStatuses.refresh()
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formStatus.setErrors(error.message)
          resolve(error)
        })
      })
    },

    async onPutFormStatus () {
      return new Promise(resolve => {
        AdminStatusService.put(this.status).then(({ data }) => {
          this.$bvModal.hide('modal-status')
          this.state.busy = false
          this.$swal.fire({
            icon: 'success',
            title: 'Successful',
            text: data.message,
            confirmButtonColor: '#06C270',
            confirmButtonText: 'Dismiss'
          }).then(() => {
            const row = _.find(this.$refs.tableStatuses.localItems, { id: data.status.id })
            row.status_name = data.status.status_name
            row.attachable = data.status.attachable
            row.costable = data.status.costable
            row.active = data.status.active
            row.updated_at = data.status.updated_at
          })
        }).catch(error => {
          this.state.busy = false
          this.$refs.formStatus.setErrors(error.message)
          resolve(error)
        })
      })
    }
  }
}
</script>
